export default function LegalAcceptance({ checked, onChange, onOpen, disabled = false }) {
  return <div className="flex items-start gap-3 rounded-xl border border-[#E1E9FC] bg-[#F7F9FE] p-4">
    <input id="legal-acceptance" type="checkbox" required checked={checked} disabled={disabled}
      onChange={event => onChange(event.target.checked)} aria-labelledby="legal-acceptance-label"
      className="mt-1 h-5 w-5 shrink-0 cursor-pointer accent-[#396BE9]" />
    <div id="legal-acceptance-label" className="text-sm leading-relaxed text-[#545454]">
      <label htmlFor="legal-acceptance" className="cursor-pointer">He leído y acepto los </label>
      <button type="button" onClick={() => onOpen("terms")} className="font-semibold text-[#396BE9] underline">Términos y Condiciones</button>
      {" y la "}
      <button type="button" onClick={() => onOpen("privacy")} className="font-semibold text-[#396BE9] underline">Política de Privacidad</button>.
    </div>
  </div>;
}
